// DepartmentDropdown.js

import React, { useEffect, useState } from "react";
import { Form, Select } from 'antd';
import DepartmentsApi from '../Apis/DepartmentsApi';
import {
    ReloadOutlined,
    SyncOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";

const DepartmentModelGoodInward = ({ SetDepartment }) => {
    console.log(SetDepartment)
    const [departments, setDepartments] = useState([]);
    const [loading, setLoading] = useState(false);
    const [TotalPageNew, setTotalPageNew] = useState(null);
    const [page, setPage] = useState(0);

    const [IsReloadDepartmentClicked, setIsReloadDepartmentClicked] =
        useState(false);
    const handleReloadDepartmentClick = () => {
        DepartmentsApi.ListDepartments(0, 100)
            .then((response) => {
                setTotalPageNew(response.totalPages);
                setDepartments(response?.payloadDto)
                setPage(prevPage => prevPage + 1);
                setLoading(false);

            })
            .catch((err) => {
                console.log(err);
            });
        setIsReloadDepartmentClicked(true);
        setTimeout(() => {
            setIsReloadDepartmentClicked(false);
        }, 1000);
    };

    const fetchDepartments2 = async () => {
        try {
            setLoading(true);
            DepartmentsApi.ListDepartments(page, 100)
                .then((response) => {
                    // setDepartments(response?.payloadDto);
                    setTotalPageNew(response.totalPages);
                    setDepartments(prevDepartments => [...prevDepartments, ...response?.payloadDto]);

                    setPage(prevPage => prevPage + 1);
                    setLoading(false);

                })
                .catch((err) => {
                    console.log(err);
                });
        } catch (error) {
            console.error('Error fetching departments:', error);
        } finally {
            setLoading(false);
        }
    };
    const handleScroll = (e) => {
        const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
        const nearBottom = e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight + 1; // Add a small buffer
        if (bottom || nearBottom) {
            if (TotalPageNew > page) {
                fetchDepartments2();
            }
        }
    };
    useEffect(() => {
        fetchDepartments2();
    }, []);

    return (
        <> <div className="row product-row d-flex align-items-center">
            <Form.Item
                name="institutionId"
                label="Department :"
                className="text-lable pt-3 col-10"
                rules={[
                    {
                        required: true,
                        message: "Please Select Department.",
                    },
                ]}
            >
                <Select
                    className="control-Select mb-1"
                    placeholder="Select Department"
                    onPopupScroll={handleScroll} // Add scroll event listener
                >
                    {departments.filter(item => item?.id === SetDepartment?.institutionDTO?.id).map((option, index) => (
                        <Select.Option key={option.id} value={option.id}>
                            {option.institutionName}
                        </Select.Option>
                    ))}
                    {loading && (
                        <Select.Option disabled key="loading" value="loading">
                            Loading...
                        </Select.Option>
                    )}
                </Select>
            </Form.Item>
            <div className=" col-1 d-flex justify-content-center">
                {IsReloadDepartmentClicked ? (
                    <div className="refresh-btn">
                        <SyncOutlined spin className="px-2" />
                    </div>
                ) : (
                    <div
                        className="refresh-btn"
                        onClick={handleReloadDepartmentClick}
                        style={{ cursor: "pointer" }}
                    >
                        <ReloadOutlined className="px-2" />
                    </div>
                )}
            </div>
        </div>
            <div className="row">
                <div className="col-4"></div>
                <div className="col-6" style={{ paddingLeft: "30px" }}>
                    <Link
                        to={"/masters/departments/add-department"}
                        target="_blank"
                    >
                        <u>Create New Department</u>
                    </Link>
                </div>
            </div>
        </>

    );
};

export default DepartmentModelGoodInward;
